export const DEAL_STATUS_SOLD = 'Sold';

export const SEND_TO_DESK_SUCCESS_MESSAGE = 'Deal sent to the desk';
